import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import i18n from '@/i18n'
import '@/sass/overrides.sass'
import '@/sass/hrvec-theme.scss'

Vue.use(Vuetify)

// พาเลตต์หลักของระบบ:
//   พื้นขาวเป็นหลัก / แดงอาชีวศึกษา = Brand Accent (ปุ่มหลัก เมนูที่เลือก เส้นเน้น)
//   กรมท่า = หัวข้อและข้อมูลสำคัญ (secondary) / ฟ้า-เทาอ่อน = พื้นที่ข้อมูลและเส้น Data Flow (info)
//   พื้นที่ใหญ่ใช้แดงอ่อน (--hv-red-soft) แทนแดงเข้ม
// สีสถานะ: สำเร็จ = เขียวเข้ม, เตือน = อำพัน, ผิดพลาด = แดง — ห้ามเพิ่มโทนม่วง/ชมพู/ฟ้าสดกลับเข้ามา
// ค่าเดียวกันนี้ประกาศเป็น CSS variable ใน src/sass/hrvec-theme.scss ด้วย (แก้ทั้งสองที่ให้ตรงกัน)
const theme = {
  primary: '#B3151B',
  secondary: '#1B365D',
  accent: '#8E1014',
  info: '#2B6CB0',
  success: '#2E7D32',
  warning: '#A86400',
  error: '#C62828',
  deep: '#8E1014',
}

export default new Vuetify({
  lang: {
    t: (key, ...params) => i18n.t(key, params),
  },
  theme: {
    themes: {
      dark: theme,
      light: theme,
    },
  },
})
